import ButtonBase from '@material-ui/core/ButtonBase';
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { DotProps } from 'react-multi-carousel';
import clsx from 'clsx'

const CustomDot = ({ index, onClick, active }: DotProps) => {
  const classes = useStyles();

  return (
    <li className={classes.dotContainer}>
      <ButtonBase
        onClick={(e) => {
          if (onClick) onClick();
          e.preventDefault();
        }}
        className={clsx({
          [classes.dot]: true,
          [classes.activeButton]: active,
        })}
      />
    </li>
  );
};

export default CustomDot;

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    dotContainer: {
      margin: 10,
    },
    dot: {
      width: 12,
      height: 12,
      border: "2px solid #6464640d",
      background: theme.palette.primary.contrastText,
      borderRadius: 15,
      boxShadow: theme.shadows[1],
    },
    activeButton: {
      width: 36,
      height: 12,
      background: "#0047BA",
      border: "1px solid #0047BA",
      borderRadius: 15,
    },
  })
);